import React from 'react';


const tecno = [
    { T: 'Oracle', L: 'https://www.mysql.com/' },
    { T: 'C#', L: 'https://docs.microsoft.com/en-us/dotnet/csharp/' },



];

class Cinegon extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">






                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>Cinegon</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <iframe src="https://www.youtube.com/embed/vduaXbgnnLw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>This version of the application created with C # allows you to upload movies to an oracle database, store their cover images and then display them on the screen.</p>

                        <a href="https://github.com/BrandonGrimaldoM/Cinegon" target="_blank" rel="noreferrer">
                            <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Cinegon;